import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4, migrateReduxSessionStorageFilterValue, sessionStorageMF, setFilterValue } from '@medifind/zustand';

const options = [
  { value: 'Active, not recruiting', display: 'Active, not recruiting' },
  { value: 'Recruiting', display: 'Recruiting' },
  { value: 'Open', display: 'Open' },
  { value: 'Enrolling by invitation', display: 'Enrolling by invitation' },
  { value: 'Not yet recruiting', display: 'Not yet recruiting' },
  { value: 'Completed', display: 'Completed' },
];
if (process.env.NX_APP === 'MediFind-Pro') {
  options.push(
    { value: 'Terminated', display: 'Terminated' },
    { value: 'Withdrawn', display: 'Withdrawn' },
    { value: 'Suspended', display: 'Suspended' },
    { value: 'Withheld', display: 'Withheld' },
    { value: 'Unknown status', display: 'Unknown status' },
  );
}
const initialSelection =
  process.env.NX_APP === 'MediFind' ? options.filter((o) => ['Recruiting', 'Open', 'Enrolling by invitation'].includes(o.value)) : [];

export const initialState = {
  display: 'Status',
  name: 'trialStatus',
  type: 'multiSelect',
  selected: initialSelection,
  selectedVal: initialSelection.map((p) => p.value),
  options: options,
};
export const trialStatusInitialState = initialState;
const storeName = 'trialStatus';
export const useTrialStatusFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateTrialStatusFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'trialStatus' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateTrialStatusFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'trial_status', action: 'select', item_id: value }, 'd71e67d6-fec6-4112-b3c1-a13ee8cbd35a');
  }
  setFilterValue(useTrialStatusFilter, option);
};

export const clearTrialStatusFilterOption = () =>
  useTrialStatusFilter.setState({ ...initialState }, false, {
    type: 'clearTrialStatusFilterOption',
  });
